import React from 'react';
import { TEXT_SIZES } from './TextEditor.constants';

export const TextEditorHeader = React.memo(() => {
  return (
    <>
      <span className="ql-formats">
        <select className="ql-color" />
        <select className="ql-background" />
      </span>

      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-strike" />
      </span>

      <span className="ql-formats">
        <select className="ql-size">
          {TEXT_SIZES.map((size) => (
            <option key={size} value={size}>
              {parseInt(size)}
            </option>
          ))}
        </select>
      </span>

      <span className="ql-formats">
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />
      </span>
      <span className="ql-formats">
        <button className="ql-link" />
      </span>
    </>
  );
});
